@if (toastrs().length > 0) {
<div class="toastr-container" role="alert" aria-live="assertive" aria-atomic="true">
  @for (toastr of toastrs(); track toastr.id) {
  <div class="toastr" [class]="'toastr--' + toastr.type">
    <div class="toastr_content">
      <div class="toastr_body">
        <div class="toastr_summary">{{ toastr.summary }}</div>
        @if (toastr.detail) {
        <div class="toastr_detail">{{ toastr.detail }}</div>
        }
      </div>
      <button type="button" class="toastr_close" (click)="dismiss(toastr.id)" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  }
</div>
}